<template>
  <section>
    <!-- 统计文字 -->
   
    <el-row style="padding:15px;background:#fff">
    	
      <el-col :sm="24" :xs="24" >
        <el-row :gutter="10">
          <el-button size="small" type="primary" @click="goback" icon="el-icon-back">返回</el-button>
          <!--<el-date-picker size="small" v-model="pdata.date" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>-->
           <el-date-picker class="xs24" v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="今天" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
          <el-select style="width:150px;" size="small" v-model="chooseProduct.name" filterable  placeholder="请输入/选择小程序名称">
              <el-option v-for="item in IssAppList" :key="item.id" :label="item.name" :value="item.id" @click.native="changeProduct(item)" default-first-option></el-option>
          </el-select>
          <el-select style="width:150px;" size="small" v-model="pdata.type" clearable placeholder="请选择采集来源">
              <el-option v-for="item,index in config" :key="index+1" :label="item" :value="index+1"></el-option>
          </el-select>
          <el-select style="width:150px;" size="small" v-model="pdata.company" multiple filterable placeholder="请选择对应公司">
              <el-option v-for="item in companys" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <el-select style="width:150px;" size="small" v-model="pdata.channel_id" filterable  multiple placeholder="请选择对应渠道">
              <el-option v-for="item,index in ChannelList" :key="item.id" :label="item.ald_channel" :value="item.id"></el-option>
          </el-select>
          
           <!--新增筛选类型条件-->
         <!--<el-select size="small" v-model="pdata.ctype" filterable clearable  placeholder="请选择">
            <el-option label="非矩阵" value="1"></el-option>
            <el-option label="矩阵" value="2"></el-option>
            <el-option label="换量" value="3"></el-option>
          </el-select>-->
            <!--新增筛选状态条件-->
          <!--<el-select size="small" v-model="pdata.real" filterable clearable  placeholder="请选择">
            <el-option label="实际新增不为0" value="1"></el-option>
            <el-option label="实际活跃不为0" value="2"></el-option>
            <el-option label="全选" value="0"></el-option>
          </el-select>-->
          
          <el-select size="small" v-model="pdata.data_source" filterable clearable  placeholder="导量来源">
            	<el-option  label="矩阵导量" value="1"></el-option>
					   	<el-option  label="广点通导量" value="2"></el-option>
					   	<el-option  label="外部渠道导量" value="3"></el-option>
          </el-select>
          
       		<el-select size="small" v-model="pdata.product_belongs" filterable clearable  placeholder="产品归属">
            <el-option  label="内部矩阵" value="1"></el-option>
				   	<el-option  label="外部渠道" value="2"></el-option>
          </el-select>
					 

          
          
          
          <el-select  style="width:150px;" v-model="pdata.status" size="small" filterable  placeholder="请选择状态" @change="statusChange">
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="1"></el-option>
              <el-option label="已通知下线" value="0"></el-option>
              <el-option label="已确认下线" value="2"></el-option>
          </el-select>
          <el-button size="small" type="success" @click="updateCostHander" icon="el-icon-edit" v-if="dateVal[0]==dateVal[1]">更新成本</el-button>
        </el-row>
      </el-col>
      <!--<el-col :sm="8" :xs="24">
        <div style="float:right;text-align: right;">
          <el-row :gutter="10">
            <searchApp  class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
          </el-row>
        </div>
      </el-col>-->
    </el-row>
    <el-table :data="list" style="width: 100%;" stripe  :row-class-name="tableRowClassName" show-summary :summary-method="getSummaries"  :height="height"  @expand-change="expands" class="selfTable" :default-sort = "{prop: '_visit_uv_new', order: 'descending'}">
    	 <el-table-column type="expand" prop="name" v-if="dateVal[0]!==dateVal[1]" style="padding: 0;" class="expandd">

	        <template slot-scope="s">
	        	 
	           <el-table :data="s.row.exData" :show-header="false" >
	              <el-table-column prop="d_date" label="日期" align="center" width="208px"></el-table-column>
	              <el-table-column v-if="pdata.type!=3" prop="company" label="对应公司" align="center" width="100px"></el-table-column>
	              <el-table-column prop="ald_channel" show-overflow-tooltip label="对应渠道" align="center" min-width="100px"></el-table-column>
	              <el-table-column prop="type" show-overflow-tooltip label="采集来源" align="center" min-width="100px"></el-table-column>
	              <el-table-column prop="atv" label="单价" align="center" min-width="70px" :formatter="fixed2Formatter">
	              	<template slot-scope="scope">
			                         ￥<span >{{scope.row.atv}}</span>
			            </template>
	              </el-table-column>
	              <el-table-column prop="visit_uv_new" label="买量新增" min-width="100px" align="center"  sortable :sort-method="(a,b)=>{return (a.visit_uv_new-0)-(b.visit_uv_new-0)}"></el-table-column>
				        <el-table-column prop="cost" label="买量成本" align="center" min-width="100px"  sortable :sort-method="(a,b)=>{return (a.cost-0)-(b.cost-0)}">
				        	<template slot-scope="scope">
			                         ￥<span >{{scope.row.cost}}</span>
			            </template>
				        </el-table-column>
				        <el-table-column prop="_visit_uv_new" label="实际买量新增" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a._visit_uv_new-0)-(b._visit_uv_new-0)}"></el-table-column>
				        <!--<el-table-column prop="_visit_uv_new_o" label="实际扣量新增" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a._visit_uv_new-0)-(b._visit_uv_new-0)}"></el-table-column>-->
	              <el-table-column min-width="130px" prop="_visit_uv" label="实际活跃用户" align="center" sortable :sort-method="(a,b)=>{return (a._visit_uv-0)-(b._visit_uv-0)}"></el-table-column>
				        <el-table-column prop="_cost" label="实际买量成本" :formatter="fixed2Formatter" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a._cost-0)-(b._cost-0)}">
				        	<template slot-scope="scope">
			                         ￥<span >{{scope.row._cost}}</span>
			            </template>
				        </el-table-column>
				        <el-table-column prop="cost_per" label="实际买量单价" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a.cost_per-0)-(b.cost_per-0)}">
				        	<template slot-scope="scope">
			                         ￥<span >{{scope.row.cost_per}}</span>
			            </template>
				        </el-table-column> 
				        <el-table-column prop="update_time" label="下线时间" align="center"  min-width="140px" sortable>
				            <template slot-scope="scope">
				                <span v-if="scope.row.update_time!=null && (scope.row.status==0 || scope.row.status==2)">{{scope.row.update_time}}</span><span v-else>--</span>
				            </template>
				        </el-table-column>
				        <el-table-column prop="" label="操作" fixed="right" align="center"  width="290">
			            <template slot-scope="scope">
			            	        
			                <el-button size="mini" type="primary" @click.native="editProduct(scope.row,s.$index)" v-if="groupid==4||groupid==0||groupid==1">编辑</el-button>
			               <!-- <el-button v-if="scope.row.status==-1" style="width: 90px;" size="mini" type="danger" >确认下线</el-button>-->
			                <el-button v-if="scope.row.status==0" style="width: 90px;" size="mini" type="danger" @click.native="confirmOff(scope.$index,scope.row)">确认下线</el-button>
			                <el-button v-else-if="scope.row.status==1" style="width: 90px;" size="mini" type="info" disabled>正常</el-button>
			                <el-button v-else-if="scope.row.status==2" style="width: 90px;" size="mini" type="info" disabled>已确认下线</el-button>
			                <el-button v-else size="mini" type="info" style="width: 90px;" disabled>确认下线</el-button>
			            </template>
			        </el-table-column>
	             
	           </el-table>
	        </template>
	      </el-table-column>
        <el-table-column prop="app_name" show-overflow-tooltip label="发行游戏" align="center" min-width="160px"></el-table-column>
        <el-table-column prop="company" show-overflow-tooltip label="对应公司" align="center"  min-width="100px" ></el-table-column>
        <el-table-column prop="ald_channel" show-overflow-tooltip label="对应渠道" align="center" min-width="100px"></el-table-column>
				<el-table-column prop="type" show-overflow-tooltip label="采集来源" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="atv" label="单价" align="center" min-width="70px" :formatter="fixed2Formatter">
        	<template slot-scope="scope">
                      ￥<span >{{scope.row.atv}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="visit_uv_new" label="买量新增" min-width="100px" align="center"  sortable :sort-method="(a,b)=>{return (a.visit_uv_new-0)-(b.visit_uv_new-0)}"></el-table-column>
        <el-table-column prop="cost" label="买量成本" align="center" min-width="100px"  sortable :sort-method="(a,b)=>{return (a.cost-0)-(b.cost-0)}">
        	<template slot-scope="scope">
                      ￥<span >{{scope.row.cost}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="_visit_uv_new" label="实际买量新增" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a._visit_uv_new-0)-(b._visit_uv_new-0)}"></el-table-column>
        <!--<el-table-column prop="_visit_uv_new_o" label="实际扣量新增" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a._visit_uv_new-0)-(b._visit_uv_new-0)}"></el-table-column>-->
        <el-table-column min-width="130px" prop="_visit_uv" label="实际活跃用户" align="center" sortable :sort-method="(a,b)=>{return (a._visit_uv-0)-(b._visit_uv-0)}"></el-table-column>
        <el-table-column prop="_cost" label="实际买量成本" :formatter="fixed2Formatter" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a._cost-0)-(b._cost-0)}">
        	<template slot-scope="scope">
                      ￥<span >{{scope.row._cost}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cost_per" label="实际买量单价" min-width="130px" align="center" sortable :sort-method="(a,b)=>{return (a.cost_per-0)-(b.cost_per-0)}">
        	<template slot-scope="scope">
                      ￥<span >{{scope.row.cost_per}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="下线时间" align="center"  min-width="140px" sortable>
            <template slot-scope="scope">
                <span v-if="scope.row.update_time!=null && (scope.row.status==0 || scope.row.status==2)">{{scope.row.update_time}}</span><span v-else>--</span>
            </template>
        </el-table-column>

        <el-table-column prop="" label="操作" fixed="right" align="center"  width="290">
            <template slot-scope="scope" >
            	  <el-button size="mini" type="primary" @click="$router.push({name:'更多数据',params:{issued_app_id:scope.row.issued_app_id},query:{sdate:pdata.sdate,edate:pdata.edate,getWhich:'买量详情'}})">回本详情</el-button>
								<el-button size="mini" type="primary" @click.native="editProduct(scope.row,'')" v-if="(groupid==4||groupid==0||groupid==1)&&(dateVal[0]===dateVal[1])">编辑</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>-->
		
		
		
		<el-dialog title="编辑实际买量" :visible.sync="editDialog" width="550px" :close-on-click-modal="false">
     	 <el-form :model="chooseEditProduct">
     	 	 <el-row :gutter="10">
                 <el-col :sm="12" :xs="12" >
                    <el-form-item label="实际活跃用户">
                         <el-input-number size="small" v-model="chooseEditProduct.visit_uv_input" :step="1" :precision="0" :min="0" label="" :controls="false"></el-input-number>
                    </el-form-item>
                 </el-col>
			     	 	 	<el-col :sm="12" :xs="12" v-if="chooseEditProduct.type!=5">
                    <el-form-item label="实际买量新增">
                        <el-input-number size="small" v-model="chooseEditProduct.visit_uv_new_input" :step="1" :precision="0" :disabled="chooseEditProduct._visit_uv_new_o!=0"  @change="visitUvNewKeyup" :min="0" label="" :controls="false"></el-input-number>
                    </el-form-item>
			     	 	 	</el-col>
                <el-col :sm="12" :xs="12"  v-if="chooseEditProduct.type!=5">
                    <el-form-item label="实际扣量新增">
                        <el-input-number size="small" v-model="chooseEditProduct.visit_uv_new_o" :step="1" :precision="0"   :min="0" label="" :controls="false"></el-input-number>
                    </el-form-item>
                </el-col>
     	 	 	<el-col :sm="12" :xs="12" v-if="chooseEditProduct.type!=5">
                    <el-form-item label="实际买量成本">
                        <el-input-number size="small" :disabled="chooseEditProduct.type!=3" v-model="chooseEditProduct.cost_input" :precision="2" :min="0" label="" :controls="false"></el-input-number>
                    </el-form-item>
     	 	 	</el-col>
     	 	 
     	 	 	<el-col :sm="12" :xs="12" v-if="chooseEditProduct.type!=3 ">
                    <el-form-item label="买量单价">
                        <el-input-number size="small" v-model="chooseEditProduct.atv" :precision="2" @change="atvKeyup" :min="0" label="" :controls="false"></el-input-number>
                    </el-form-item>
     	 	 	</el-col>
     	 	 	<el-col :sm="12" :xs="12">
                    <el-form-item label="采集来源">
                        <el-select size="small" v-model="chooseEditProduct.type" placeholder="请选择计价方式" @change="typeKeyup">
                            <el-option v-for="item,index in config" :key="item" :label="item" :value="index+1"></el-option>
                        </el-select>
                    </el-form-item>
     	 	 	</el-col>
     	 	 </el-row>	
     	
	
     	 
     	 </el-form>
     	 <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click.native="editChooseProduct">确 定</el-button>
      </div>
     
     </el-dialog>

  </section>
</template>

<script>
import $ from "jquery";	
import { updateCost,confirmOff,getcostDailyDetail,getcostDailyDetailForDays, selectCompany,getIssuedAppList,getIssuedAldChanneList,visitUVNewEdit, getAppid } from "../../api/api";
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      chartColumn: null,
      pholder: "",
      chooseProduct:{name:"",id:''},
      pdata: {
        issued_app_id: "",
        company:"",
        channel_id:"",
        type:"",
        kw: "",
        real:"0",
        ctype:"",
        data_source:"",
        product_belongs:"",
//      date: new Date(new Date().getTime() - 3600 * 1000 * 24).toISOString().slice(0, 10),
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 2 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        status:""
      },
      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000 * 2 * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      IssAppList:[],
      list:[], //所有数据
      companys:[],
      ChannelList:[],
      chooseEditProduct:{
      	visit_uv_new_input:'',
    	type:'',
    	cost_input:'',
    	atv:'',
    	index_id:'',
    	_visit_uv_new_o:'',
    	visit_uv_new_o:'',
    	buy_source:'',
      },
      toggleRowExpansionNum:'',
      height:900,
    };
  },
  watch: {
  	'pdata.channel_id':{
  		  handler(n, o) {
        if (n) {
          this.pdata.channel_id = n;
          this.getList();
        }
      },
      deep: true
  	},
  	'pdata.company': {
      handler(n, o) {
        if (n) {
          this.pdata.company = n;
          this.getList();
        }
      },
      deep: true
   },
   'pdata.type': {
      handler(n, o) {
      
          this.getList();
       
      },
      deep: true
   },
    'pdata.ctype': {
      handler(n, o) {
      
          this.getList();
      
      },
      deep: true
   },
   'pdata.real': {
      handler(n, o) {
      
				this.getList();
       
      },
      deep: true
   },
   'pdata.data_source': {
      handler(n, o) {
      
				this.getList();
       
      },
      deep: true
   },
   'pdata.product_belongs': {
      handler(n, o) {
      
				this.getList();
       
      },
      deep: true
   },
   dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
					
					//this.$router.push({ name:'成本日报详情',params:{issued_app_id:this.pdata.issued_app_id},query: {sdate:this.pdata.sdate,edate:this.pdata.edate} });

					this.getList();
					
     
        }
      },
      deep: true
    },
  },
  methods: {
	  		getSummaries(param) {
		    const { columns, data } = param;
		    const sums = [];
		    columns.forEach((column, index) => {
		      if (index === 0) {
		        sums[index] = '合计';
		        return;
		      }
	
		      if(this.dateVal[0]==this.dateVal[1]){
		      	 if(index === 4||index===11){
		      	 		 sums[index] = '-';
		      	 			return;
		      	 }
		      }
		      else{
		      	if(index === 5||index===12){
		      	 		 sums[index] = '-';
		      	 			return;
		      	 }
		      }
		      
		   	
	
		     
		      const values = data.map(item => Number(item[column.property]));
		      if (!values.every(value => isNaN(value))) {
		      
		        sums[index] = values.reduce((prev, curr) => {
		          const value = Number(curr);
		          if (!isNaN(value)) {
		            return prev + curr;
		          } else {
		            return prev;
		          }
		        }, 0);
		        if(index===6||index===9||index===10){
		      		sums[index] ='￥'+sums[index].toFixed(2)  ;
		      	}
		        else{
		        	sums[index] = sums[index] ;
		        }
		        
		      } else {
		        sums[index] = '-';
		      }
		    });
		
		    return sums;
		  },
      fixed2Formatter(row, column, cellValue, index){
          if(cellValue=='-'){
              return '-';
          }else if(cellValue==null || cellValue==undefined){
              return '0.00';
          }else{
              return parseFloat(cellValue).toFixed(2);
          }
      },
      visitUvNewKeyup(){
          let self=this;
          if(self.chooseEditProduct.type!=3 && self.chooseEditProduct.type!=5){//非广点通或换量的，实时计算买量成本
              if(self.chooseEditProduct._visit_uv_new_o !=null && self.chooseEditProduct._visit_uv_new_o !=undefined && self.chooseEditProduct._visit_uv_new_o !=0){
              	//使用扣量新增值计算
                  self.chooseEditProduct.cost_input=(self.chooseEditProduct._visit_uv_new_o*self.chooseEditProduct.atv).toFixed(2);
              }
              else{
              	//使用实际新增值计算
              	// 1新增 2 活跃
                  self.chooseEditProduct.cost_input=(self.chooseEditProduct.visit_uv_new_input*self.chooseEditProduct.atv).toFixed(2);
              }
          }
      },
      atvKeyup(){
          let self=this;
          //实时计算买量成本
          if(self.chooseEditProduct._visit_uv_new_o !=null && self.chooseEditProduct._visit_uv_new_o !=undefined && self.chooseEditProduct._visit_uv_new_o !=0){//使用扣量新增值计算
              self.chooseEditProduct.cost_input=(self.chooseEditProduct._visit_uv_new_o*self.chooseEditProduct.atv).toFixed(2);
          }else{//使用实际新增值计算
          		// 1新增 2 活跃
          		if( self.chooseEditProduct.buy_source=='1'){
          			self.chooseEditProduct.cost_input=(self.chooseEditProduct.visit_uv_new_input*self.chooseEditProduct.atv).toFixed(2);
          		}
          		else if(self.chooseEditProduct.buy_source=='2'){
          			self.chooseEditProduct.cost_input=(self.chooseEditProduct.visit_uv_input*self.chooseEditProduct.atv).toFixed(2);
          		}
              
          }
      },
      typeKeyup(){
          let self=this;
          self.chooseEditProduct.atv=0;
          if(self.chooseEditProduct.type==5){
              self.chooseEditProduct.cost_input=0;
          }
      },
  	goback(){
  	
  		this.$router.back(-1)
  	},
  	tableRowClassName({ row, rowIndex }) {
//    if (row.clickok_uv == 0 && row.num != 0) {
//      return "warning-row";
//    }
      if (row.status==0 || row.status==2) {
          return 'warning-row';
      }
      return "";
   },
    getIssAPPList(){
		var p="";
		getIssuedAppList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.IssAppList = res.data;
          this.IssAppList.forEach((v,i)=>{
          	if(v.id==this.pdata.issued_app_id ){
          		this.chooseProduct.name=v.name;
          	}
          })
        }
      });
	},
    statusChange(v) {
      this.pdata.status = v;
      this.list=[];
      this.getList();
    },
    updateCostHander(){
    	debugger;
      console.log("issued_app_id:"+this.pdata.issued_app_id);

      this.$confirm('确定更新成本吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
      }).then(() => {

          let d_date=this.pdata.sdate.split("-").join("");
          updateCost({"issued_app_id":this.pdata.issued_app_id,"d_date":d_date}, this.$cookie.getCookie("login")).then(res => {
              if (res.code == 200) {
                  this.$message({ message: "更新成本成功", type: "success" });
              } else if (res.code == 400){
                  this.$message({ message: res.msg, type: "warning" });
              } else{
                  this.$message.error(res.msg);
              }
          });

      }).catch(() => {
      });

    },
    confirmOff(index,row){

      this.$confirm('确定下线吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
      }).then(() => {

        confirmOff({"channel_id":row.channel_id, "status":"2"}, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.$message({ message: "下线成功", type: "success" });
            //this.list[index].status="2";
            this.getList();
          }
          else{
              this.$message.error('下线失败');
          }
        });

      }).catch(() => {
      });

    },
    expands(r, es) {

      var isshou = false;
      if (es.length > 0) {
        es.forEach(v => {
          if (v.issued_app_id == r.issued_app_id) {
            isshou = true;
          }
        });
      }
      if (isshou) {
        var p = `issued_app_id=${r.issued_app_id}&channel_id=${r.channel_id}&sdate=${this.dateVal[0]}&type=${this.pdata.type}&edate=${
          this.dateVal[1]
        }`;

        getcostDailyDetailForDays(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            r.exData = res.data.list;
            this.$forceUpdate();
          }
         
        });
      }
    },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getcostDailyDetail(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
          if(res.data.list&&res.data.list.length>0){
          	 res.data.list.forEach((x,i) => {
	            	x.keyid='key'+i;
	              x.exData = [];
	              x.ex
	            });
	            this.list=res.data.list;
	            
	            setTimeout(()=>{
	            	if(this.toggleRowExpansionNum!==''){
		            	document.getElementsByClassName('el-table__expand-icon')[this.toggleRowExpansionNum].click();
		            	//this.toggleRowExpansionNum='';
		            }
	            },500)
	          
          }
          else{
          		this.list=[];
          }
          
          
        }
      });
    },
    fetchCompany(){
    	  var p = "";
	      for (var k in this.pdata) {
	        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
	        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
	      }
    	  selectCompany(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	
          if(res.data&&res.data.length>0){
	            this.companys=res.data;
          }
          else{
          		this.companys=[];
          }
          
          
        }
      });
    },
    fetchIssuedAldChanneList(){
    	  var p = "";
	      for (var k in this.pdata) {
	        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
	        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
	      }
    	  getIssuedAldChanneList(p, this.$cookie.getCookie("login")).then(res => {

        if (res.code == 200) {
        
        	
          if(res.data.list&&res.data.list.length>0){
	            this.ChannelList=res.data.list;
          }
          else{
          		this.ChannelList=[];
          }
          
          
        }
      });
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeCom(v){
    	
    	this.getList();
    },
    changeId(res) {
      this.pdata.issued_app_id = res;
      this.getList();
    },
    editProduct(row,s){
    	if(s!==''){
    		this.toggleRowExpansionNum=s;
    	}
    	else{
    		this.toggleRowExpansionNum='';
    	}
    	this.editDialog=true;
    	this.chooseEditProduct={
    				buy_source:row.buy_source,
            visit_uv_input:row._visit_uv,
    				visit_uv_new_input:row._visit_uv_new || row.visit_uv_new,
    				_visit_uv_new_o:row._visit_uv_new_o,
            visit_uv_new_o:row._visit_uv_new_o,
		    		type:row.type,
		    		cost_input:row._cost,
		    		atv:row.atv,
		    		index_id:row.index_id,
    	};
    	switch(row.type){
    		case '阿拉丁':this.chooseEditProduct.type=1;
    		break;
    		case '微信':this.chooseEditProduct.type=2;
    		break;
    		case '广点通':this.chooseEditProduct.type=3;
    		break;
    		case '内部矩阵':this.chooseEditProduct.type=4;
    		break;
            case '阿拉丁换量':this.chooseEditProduct.type=5;
            break;
    	}
    	
    },
	   changeProduct(res){
		 	 this.pdata.issued_app_id=res.id;
		 	 this.getList();
		 	 this.fetchIssuedAldChanneList();
    	 this.fetchCompany();
		 	 
	
		 	 
		 },
		getConfig() {
			
	     if (this.$store.config) {
	       this.config = this.$store.config.get_channel_price_type;
	     } else {
	       setTimeout(() => {
	         this.getConfig();
	       }, 50);
	     }
	   },
    editChooseProduct(){
	   var p = JSON.parse(JSON.stringify(this.chooseEditProduct))
	   	if(this.chooseEditProduct.type!=3){
	   		p.cost_input=0
	   	}
   			
  	 	visitUVNewEdit(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	 this.editDialog=false;
        	  this.$message({ message: "修改成功", type: "success" });
            // "访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"
            this.getList();
        }
        else{
        	this.$message.error('修改失败');
        }
      });
    },
  },
  computed: {
    ...mapGetters([
    	'groupid'
    ])
  },
  created(){
  	
  	console.log($(window).height()-200);
  	this.height=$(window).height()-200
  },

  mounted() {

    this.pdata.issued_app_id = this.$route.params.issued_app_id;
//  if(this.$route.query.date){
//      this.pdata.date = this.$route.query.date;
//  }
//  
    if(this.$route.query.sdate){
    	  this.pdata.sdate=this.$route.query.sdate;
    }
    if(this.$route.query.edate){
    	 this.pdata.edate=this.$route.query.edate;
    }
    if(this.$route.query.channel_id){
    	this.pdata.channel_id.push(this.$route.query.channel_id);
    }
  	this.dateVal = [this.pdata.sdate,this.pdata.edate];

    this.getList();
    this.getIssAPPList();
    this.fetchIssuedAldChanneList();
    this.fetchCompany();
    this.getConfig();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
.el-input-number{
    max-width: 215px;width:100%;
}
.el-input-number .el-input__inner{
    text-align: left;
}
.selfTable .el-table__expanded-cell[class*=cell]{
	padding:0;
}
</style>


<style scoped="scoped">
	.red{
		color: #FF0000;
	}
</style>


// WEBPACK FOOTER //
// costDailyDetail.vue?465e9642